import { render, staticRenderFns } from "./BaseAccessChange.vue?vue&type=template&id=ba3a3486&scoped=true"
import script from "./BaseAccessChange.vue?vue&type=script&lang=js"
export * from "./BaseAccessChange.vue?vue&type=script&lang=js"
import style0 from "./BaseAccessChange.vue?vue&type=style&index=0&id=ba3a3486&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3a3486",
  null
  
)

export default component.exports